var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"loader",class:{ inline: _vm.inline }},[(!_vm.inline)?_c('div',{staticClass:"loader-animation"}):_vm._e(),_c('div',{staticClass:"loader-single",class:{ small: _vm.small }}),(!_vm.inline)?_c('p',[_vm._v(_vm._s(_vm.$t("global.loading")))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }